import { escape } from 'lodash';

import { submitConferenceFF } from '../../../utils/services';

export const UPDATE_FIELD_VALUE_FF = 'UPDATE_FIELD_VALUE_FF';
export const UPDATE_FORM_STATUS_FF = 'UPDATE_FORM_STATUS_FF';
export const SUBMIT_IN_PROGRESS_FF = 'SUBMIT_IN_PROGRESS_FF';
export const SUBMIT_SUCCESS_FF = 'SUBMIT_SUCCESS_FF';
export const SUBMIT_ERROR_FF = 'SUBMIT_ERROR_FF';
export const RESET_FORM_FF = 'RESET_FORM_FF';

const submitInProgress = () => ({
    type: SUBMIT_IN_PROGRESS_FF,
    payload: {}
});

const submitSuccess = () => ({
    type: SUBMIT_SUCCESS_FF,
    payload: {}
});

const submitError = error => ({
    type: SUBMIT_ERROR_FF,
    payload: error
});

export const updateValue = event => dispatch => {
    const { name, value } = event.target;

    dispatch({
        type: UPDATE_FIELD_VALUE_FF,
        payload: { name, value }
    });
};

export const submitFFForm = () => async (dispatch, getState) => {
    dispatch(submitInProgress());
    try {
        const { fields } = getState().feedbackForm;
        const data = {};
        Object.keys(fields).forEach(key => {
            data[key] = escape(fields[key].value);
        });
        await submitConferenceFF(data);
        dispatch(submitSuccess());
    } catch (error) {
        const resp = error.response ? error.response.data : { msg: '' };
        dispatch(submitError(resp));
    }
};

export const updateFormStatus = (fieldName, value) => ({
    type: UPDATE_FORM_STATUS_FF,
    payload: {
        fieldName,
        value
    }
});

export const resetFormAction = () => ({ type: RESET_FORM_FF });
